import endMailListLoadDatapoint from "./endMailListLoadDatapoint";
import getMailListLoadErrorStatus from "./getMailListLoadErrorStatus";
import { getStore as getListViewStore } from "owa-mail-list-store";
import { addPASKeyMetric } from "owa-performance";

export default function onMailListLoaded(componentRendered: string, tableViewId: string, loadId?: number): void {
    const tableView = getListViewStore().tableViews.get(tableViewId) ?? null;
    
    // When the mail list resolved to an error state, end the datapoint with the mapped
    // error status (ServerError/ClientError) instead of the default success status.
    // Derived from the table's loadErrorStatus.
    const overrideStatus = tableView
        ? getMailListLoadErrorStatus(tableView.loadErrorStatus)
        : undefined;
    
    // PAS only records the first write, so this captures when the boot mail list first painted
    // rows ('VML') or a legitimately empty list ('EmptyML'), excluding error/offline states.
    if (overrideStatus === undefined && componentRendered !== "EmptyML_Error") {
        addPASKeyMetric("MailAppLoadSucceeded");
    }
    
    endMailListLoadDatapoint(componentRendered, tableViewId, loadId, false /* shouldInvalidate */, overrideStatus);
}
